/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE: you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { IgrGridColumnHideOptions } from './igr-grid-column-hide-options';
import { GridColumnHideOptions } from './GridColumnHideOptions';
import { TypeRegistrar } from "igniteui-react-core";
var IgrGridColumnHideOptionsModule = /** @class */ /*@__PURE__*/ (function () {
    function IgrGridColumnHideOptionsModule() {
    }
    IgrGridColumnHideOptionsModule.register = function () {
        TypeRegistrar.registerCons('IgrGridColumnHideOptions', IgrGridColumnHideOptions);
        TypeRegistrar.registerCons('IgrGridColumnHideOptions', IgrGridColumnHideOptions);
        TypeRegistrar.register('GridColumnHideOptions', GridColumnHideOptions.$type);
    };
    return IgrGridColumnHideOptionsModule;
}());
export { IgrGridColumnHideOptionsModule };
//# sourceMappingURL=igr-grid-column-hide-options-module.js.map
